/**
 * Ajout panier — nuancier complet (autonome, ne dépend pas de product-form).
 */
(function () {
  'use strict';

  const HANDLE = 'nuancier-complet-biocemento';

  function readConfig() {
    for (const id of ['BioConversionConfig', 'BioElixirConfig']) {
      const el = document.getElementById(id);
      if (!el) continue;
      try {
        return JSON.parse(el.textContent);
      } catch (e) {
        /* ignore */
      }
    }
    return {};
  }

  function shopifyRoot() {
    const root = window.Shopify?.routes?.root;
    if (root) return root.endsWith('/') ? root : `${root}/`;
    const cfg = readConfig();
    const fallback = cfg.routes?.root || '/';
    return fallback.endsWith('/') ? fallback : `${fallback}/`;
  }

  async function resolveVariantId(btn) {
    const fromBtn = btn.dataset.variantId;
    if (fromBtn) return Number(fromBtn);

    const cfg = readConfig();
    if (cfg.nuancierVariantId) return Number(cfg.nuancierVariantId);

    const handle = btn.dataset.productHandle || cfg.nuancierHandle || HANDLE;
    const res = await fetch(`${shopifyRoot()}products/${handle}.js`);
    if (!res.ok) throw new Error('Nuancier introuvable');
    const product = await res.json();
    const variant = product.variants?.find((v) => v.available) || product.variants?.[0];
    if (!variant?.id) throw new Error('Nuancier indisponible');
    return variant.id;
  }

  async function addToCart(variantId) {
    const root = shopifyRoot();
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } })
    );
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sections.join(','),
      }),
    });

    const json = await res.json();
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

    if (!res.ok) {
      throw new Error(json.description || json.message || 'Impossible d’ajouter au panier');
    }

    const cartRes = await fetch(`${root}cart.js`);
    const cart = await cartRes.json();
    if (json.sections) cart.sections = json.sections;

    const items = json.items || (json.id ? [json] : [{ id: variantId, quantity: 1 }]);
    const onSuccessDo = 'force_open_drawer';

    document.documentElement.dispatchEvent(
      new CustomEvent('variant:add', {
        bubbles: true,
        detail: { items, cart, onSuccessDo },
      })
    );
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', onSuccessDo, cart },
      })
    );

    if (!json.sections || !Object.keys(json.sections).length) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }

    return cart;
  }

  async function handleClick(btn, event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;

    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    const label = btn.querySelector('.bio-nuancier-atc__label') || btn;

    try {
      const variantId = await resolveVariantId(btn);
      await addToCart(variantId);
    } catch (err) {
      console.error('[bio-nuancier-atc]', err);
      window.alert(err.message || 'Impossible d’ajouter le nuancier au panier.');
    } finally {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      if (label !== btn) label.textContent = btn.dataset.labelDefault || label.textContent;
    }
  }

  function bindButtons(root) {
    root.querySelectorAll('[data-bio-nuancier-atc]').forEach((btn) => {
      if (btn.dataset.bioAtcBound === '1') return;
      btn.dataset.bioAtcBound = '1';
      if (!btn.dataset.labelDefault) {
        btn.dataset.labelDefault = btn.textContent.trim();
      }
      btn.addEventListener('click', (e) => handleClick(btn, e), true);
    });
  }

  function init() {
    bindButtons(document);
  }

  window.bioAddNuancierToCart = async function (triggerBtn) {
    const btn =
      triggerBtn ||
      document.querySelector('.bio-elixir-nuancier-box [data-bio-nuancier-atc]') ||
      document.querySelector('[data-bio-nuancier-atc]');
    if (!btn) throw new Error('Bouton nuancier introuvable');
    const variantId = await resolveVariantId(btn);
    return addToCart(variantId);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target) bindButtons(e.target);
  });
})();
